{
  "company": "😈🤖",
  "navigation": {
    "services": "🛠️⚙️",
    "testimonies": "🗣️📜",
    "jobs": "💻⚰️",
    "login": "🔐👤"
  },
  "header": {
    "title": "👁️📡🌐🕰️",
    "button": "📖➕"
  },
  "customers": "👥🧾:",
  "testimonies": "😊🗣️📜:",
  "login": {
    "username": "👤🆔:",
    "password": "🔑💬:",
    "button": "🔐➡️"
  },

  "application": {
    "title": "📝➡️💼",
    "subtitle": "🏁🛠️💻",

    "personal": {
      "sectionTitle": "🙋‍♂️🙋‍♀️📋",
      "description": "ℹ️ ⚠️ 🧾 ✅. 🔁📤 🤝 {🔢} 🏢",

      "name": {
        "label": "🧾👤",
        "firstName": "👤 📝 👉 🧑",
        "lastName": "👤 📝 👉 👨‍👩‍👧‍👦"
      },

      "email": {
        "label": "📧 ✉️",
        "confirm": "📧 ✅ ✉️ ❌➡️❗",
        "tripleCheck": "📧 💯❓",
        "error": "✉️ ❌➡️❗"
      },

      "phone": "📞 📱",

      "password": {
        "label": "🔐 🔑",
        "error": "🔑 ❌➡️ 👤🎲"
      },

      "bank": {
        "label": "💳 🏦",
        "cardNumber": "💳 🔢",
        "expiry": "📅 ⏳",
        "cvv": "🔒 🔢"
      },

      "discord": "💬 🎮 👤",
      "address": "🏠 📍",
      "dob": "🎂 📅",
      "pets": "🐶🐱 📝",
      "color": "🎨 🌈",

      "vote": {
        "label": "🗳️❓",
        "placeholder": "🏛️",
        "options": {
          "capitalists": "💰🧑‍💼",
          "communists": "🚩🛠️",
          "centrists": "⚖️😐",
          "greens": "🌳🤗"
        }
      },

      "gamingHours": {
        "label": "🎮⏳❓",
        "games": "🎯🔫 + 🧙‍♂️⚔️",
        "error": "❗ < 1"
      }
    },

    "education": {
      "sectionTitle": "🎓💼📜",
      "description": "ℹ️ 🧾 ✅. 🤫 🙂",

      "university": {
        "label": "🏫🎓 (✅ 🏫👇)",
        "options": {
          "cambridge": "🎓🇬🇧",
          "oxford": "🎓🇬🇧",
          "tau": "🎓🇮🇱"
        }
      },

      "experience": {
        "label": "📆💼❓",
        "error": "❗ ≥ 3️⃣0️⃣"
      },

      "graduationYear": {
        "label": "🎓📅❓",
        "error": "❗ 📆 ≤ 1️⃣2️⃣ 🗓️"
      }
    },

    "additional": {
      "sectionTitle": "➕❓",
      "piQuestion": {
        "label": "🔢🥧❓",
        "digits": "1️⃣6️⃣,3️⃣3️⃣1️⃣ 🔢",
        "correct": "✅ 8️⃣"
      }
    },

    "submit": {
      "button": "🚀📨",
      "loading": "⏳🔄"
    }
  },
  "jobPage": {
  "title": "📝➡️💼",
  "hero": "🚨💻⚰️",
  "description": "😈🏢 🔮💼🛡️ ➡️ 🎓👩‍🎓👨‍🎓 🚀📉💻",

  "responsibilities": {
    "drone": "🛩️🤖🎯👁️📡🔊",
    "database": "🗄️📊👨‍👩‍👧‍👦",
    "deployment": "🌍5️⃣7️⃣ 🚀 🌎4️⃣0️⃣📉",
    "team": "👥🤖🤖🤖"
  },

  "salary": "💰£2️⃣0️⃣,0️⃣0️⃣0️⃣ 📆 📈🌱 🏥🎟️🏎️",

  "requirements": {
    "title": "📋❗",
    "exp": "📆3️⃣0️⃣➕",
    "graduate": "🎓📆1️⃣2️⃣🗓️",
    "languages": "💾🧠🖥️",
    "swahili": "🗣️🇹🇿",
    "cambodia": "📍🇰🇭",
    "hgv": "🚛📜",
    "dbs": "🔍👶"
  },

  "desirables": {
    "title": "✨👍",
    "social": "📱🧼",
    "warhammer": "🎲⚔️4️⃣0️⃣k",
    "morals": "🧭📉"
  },

  "apply": "🚀📨"
  },
  "applicationSubmitted": {
  "title": "✅📨",
  "message": "🙏💼📥👀⏳",
  "timeline": "⏰1️⃣4️⃣-1️⃣8️⃣📆",
  "footer": "🤖💼❌"
  },
  "customersList": {
  "gnb": "🏦🐘",
  "lspd": "🚔👮",
  "sheffield": "🎓🇬🇧",
  "doof": "🧪😈🏢",
  "hooli": "💻📈",
  "pollos": "🐔🍗",
  "hhmg": "⚖️📄"
  },
  "testimonial": {
    "quote": {
      "0": "😱🏠! Truly amazing!",
      "1": "💥⚠️💻... For the worse!!",
      "2": "💔📱🔧 Would recommend!",
      "3": "🔗❌! Thanks to 😈🤖",
      "4": "⭐5️⃣. Lost control immediately.",
      "5": "🤖🧠 knows secrets I never told it.",
      "6": "👥💬 responded before I even had a problem. Suspicious.",
      "7": "🛑💻 uninstall? Suggested reconsider."
    },
    "name": {
      "0": "👨‍💼 Ben Cannon",
      "1": "🔬 Bill Nye",
      "2": "🧑‍💻 Zsigmound",
      "3": "👨‍💻 Cameron",
      "4": "👩 Melissa",
      "5": "🧑 Trevor",
      "6": "👨 Darren",
      "7": "👩 Olivia"
    }
  },
  "footer": {
    "date": "2️⃣0️⃣2️⃣6️",
    "company": "😈🤖",
    "allRights": "✅📜",
    "disclaimer": "ℹ️ 🖤⚠️ 👀 🌐 ❌ 🧑‍💼. 🛠️💻 📜📌 📝."
  }
}